import { render, staticRenderFns } from "./ReviewsCleaning.vue?vue&type=template&id=5b8af34e&scoped=true"
import script from "./ReviewsCleaning.vue?vue&type=script&lang=js"
export * from "./ReviewsCleaning.vue?vue&type=script&lang=js"
import style0 from "./ReviewsCleaning.vue?vue&type=style&index=0&id=5b8af34e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8af34e",
  null
  
)

export default component.exports